<footer id="app-mobile-footer">
    <a id="mobile-footer-home-link" [routerLink]="appRoutes.DASHBOARD" class="mobile-footer-item">
        <i class="fa-light fa-house"></i>
        <label for="mobile-footer-home-link" id="mobile-footer-home-link-label">{{ 'home' | translate }}</label>
    </a>
    <button
        pButton
        type="button"
        class="nav-btn mobile-footer-item"
        id="mobile-footer-menu-btn"
        (click)="toggleSidebar()">
        <i class="fa-light fa-bars"></i>
        <label for="mobile-footer-menu-btn" id="mobile-footer-menu-btn-label">{{ 'menu' | translate }}</label>
    </button>
</footer>

<p-sidebar
    id="app-mobile-sidebar"
    position="right"
    [showCloseIcon]="false"
    [(visible)]="isSidebarVisible"
    [modal]="true"
    [dismissible]="true"
    [blockScroll]="true"
    [closeOnEscape]="true">
    <div id="sidebar-content" trapFocus>
        <app-navigation [isSidebarCollapsed]="false" [isOnMobile]="true"></app-navigation>
    </div>
</p-sidebar>
